module.exports = __webpack_public_path__ + "img/onis-royale.0eb8bc35.webp";